import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getMenu: {
        method: 'GET',
        url: `${BASE_PATH_API}/webapp/navigation/menu`,
        isArray: true,
        cache: true,
        transformResponse: function transformResponse(data) {
            return data.filter(function(item) {
                // exclude 'Settings'
                return ['Settings'].indexOf(item.Title) === -1;
            });
        }
    },

    getHelpMenu: {
        method: 'GET',
        url: `${BASE_PATH_API}/webapp/navigation/help`,
        isArray: true,
        cache: true
    },

    getSettingsMenu: {
        method: 'GET',
        url: `${BASE_PATH_API}/webapp/navigation/settings`,
        isArray: true,
        cache: true
    },

    getPropertyNavigation: {
        method: 'GET',
        url: `${BASE_PATH_API}/properties/:propertyId/navigation`,
        isArray: true
    },

    getIntegrationsMenu: {
        method: 'GET',
        url: `${BASE_PATH_API}/webapp/navigation/integrations`,
        isArray: true,
        cache: true
    },
};

export function NavigationApi() {
    return createActions(actions);
}
